var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatcherIconMoving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "catcherIconMoving_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 286",
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "catcherIconMoving_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 287",
    fill: "none",
    d: "M0 0h30v30H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "catcherIconMoving_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 509",
    fill: "none",
    d: "M0 0h12v3.6H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u9577\\u65B9\\u5F62 292",
    transform: "translate(10.8 20.4)",
    fill: "#ccc",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.4,
    height: 8.4,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7.4,
    height: 7.4,
    rx: 1.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#catcherIconMoving_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArmPower"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 313",
    fill: "#040000",
    clipPath: "url(#catcherIconMoving_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 329",
    d: "M15.011 3.228a7.421 7.421 0 00-7.5 7.339c0 2.644 1.183 5.329 3.417 6.445h8.167c2.234-1.117 3.417-3.8 3.417-6.445a7.42 7.42 0 00-7.5-7.339m0 11.923a4.728 4.728 0 114.728-4.728 4.728 4.728 0 01-4.728 4.728m0-8.924a4.2 4.2 0 104.195 4.2 4.2 4.2 0 00-4.195-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 330",
    d: "M23.004 24.379l4.444-6.786-6.08-4.116 1.072-1.8 7.167 4.958a.913.913 0 01.231 1.27l-.01.014-6.039 7.484-4.329 1.359a.228.228 0 01-.176-.419z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 331",
    d: "M7 24.379l-4.448-6.786 6.08-4.116-1.072-1.8-7.166 4.959a.913.913 0 00-.231 1.27l.01.014 6.038 7.483 4.329 1.359a.228.228 0 00.175-.419z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 1.2)",
    clipPath: "url(#catcherIconMoving_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 506",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 880",
    d: "M12 1.772L8.472.031a.434.434 0 00-.233-.026C8.156.018 8.1.05 8.1.086v3.481c0 .036.056.069.139.081a.434.434 0 00.234-.026L12 1.882c.065-.032.065-.079 0-.111"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 508",
    d: "M.092 1.066h8.709v1.523H.092z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatcherIconMoving);
export default __webpack_public_path__ + "static/media/catcherIconMoving.075db08a642077f4.svg";
export { ForwardRef as ReactComponent };